import { useState } from "react";

import { LoyaltyAllowedMatrixEditForm } from "src/app/features/LoyaltyAllowedMatrix/components/forms/LoyaltyAllowedMatrixEntityEditForm";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { RefreshButton } from "../../../../components/FeatureButtons/RefreshButton";
import { SubmitButton } from "../../../../components/FeatureButtons/SubmitButton";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";

export const LoyaltyAllowedMatrixEditFormPage = () => {
    const [runSubmit, setRunSubmit] = useState(0);
    const triggerFormSubmit = () => setRunSubmit(runSubmit + 1);
    const hasWriteAccess = canAccess(ResourceName.LOYALTY_ALLOWED_MATRIX, "canWrite");
    const hasAccess = canAccess(ResourceName.LOYALTY_ALLOWED_MATRIX, "canRead");

    return (
        <FPage>
            {hasAccess ? (
                <>
                    <FPageHeader>
                        <PageTitle translationKey="page.title.loyaltyAllowedMatrixEditFormPage" />
                        {hasWriteAccess && (
                            <ActionBar>
                                <SubmitButton isDisabled={false} onClick={triggerFormSubmit} />
                                <RefreshButton isDisabled={false} />
                            </ActionBar>
                        )}
                    </FPageHeader>
                    <FPageContent>
                        <LoyaltyAllowedMatrixEditForm runSubmit={runSubmit} />
                    </FPageContent>
                </>
            ) : (
                <NoAccessLayout />
            )}
        </FPage>
    );
};
